import { makeStyles } from '@material-ui/core'
import React from 'react'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

const homeButtonStyles = makeStyles(theme => ({
   buttonBack: {
      // position: 'absolute',
      // top: '13%',
      // left: '150px',
      backgroundColor: '#1E57E1',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      color: '#FFFFFF',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '10px',
      cursor: 'pointer',
      transition: 'transform .2s',
      '&:hover': {
         transform: 'scale(1.1)'
      }
   }
}))

function ButtonBack({ setView }) {
   const classes = homeButtonStyles()

   return (
      <div className={classes.buttonBack} onClick={() => setView('')}>
         <ArrowBackIcon />
      </div>
   )
}

export default ButtonBack
